import Tb1688api from '@/views/moving_function/views/select_goods/platform/1688/api'
import { Service_GetRelationId } from '@/service/auth_mall_service'

async function GetProductFilter() {
  const { list } = await Tb1688api.GetProductFilter(Service_GetRelationId())
  const newList = list.filter(item => {
    if (item.key === 'jxhy') item.desc = '1688小二严选'
    return ['shipIn24Hours', 'shipIn48Hours', 'isOnePsaleFreePost', 'noReason7DReturn', 'jxhy'].includes(item.key)
  })
  return newList || []
}

export default { GetProductFilter }